import PropTypes from 'prop-types';
import React from 'react';

import { Alert, Snackbar } from '@mui/material';

const Toaster = ({ type = 'success', message = 'Accion completada', open, handleClose }) => {
  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
      <Alert severity={type}>{message}</Alert>
    </Snackbar>
  );
};

Toaster.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default Toaster;
